/**
 * WordPress dependencies
 */
import { View, type WordPressComponentProps } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import { contextConnect } from '../../context';
import { useBorderBoxControlVisualizer } from './hook';

import type { VisualizerProps } from '../types';

const BorderBoxControlVisualizer = (
	props: WordPressComponentProps< VisualizerProps, 'div' >,
	forwardedRef: React.ForwardedRef< unknown >
) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { value, ...otherProps } = useBorderBoxControlVisualizer( props );

	return <View { ...otherProps } ref={ forwardedRef } />;
};

const ConnectedBorderBoxControlVisualizer = contextConnect(
	BorderBoxControlVisualizer,
	'BorderBoxControlVisualizer'
);
export default ConnectedBorderBoxControlVisualizer;
